$(document).ready(function() {
    $('#fullpage').fullpage({
        css3: true,
        menu: '#menu',
        lockAnchors: false,
        anchors: getAnchors(),
        navigation: true,
        navigationPosition: 'right',
        navigationTooltips: getAnchors(true),
        showActiveTooltip: false,
        scrollOverflow: true,
        paddingTop: '95px',
        paddingBottom: '65px',
        responsiveWidth: 768,
        afterRender: function(){
            $('a[href=#]').parent().hide();
            var number = 1;
            $('#fp-nav a').each(function(){
                if (!$(this).parent().is( ":hidden" )){
                    $(this).html(number++);
                }
            });
        },
        afterLoad: function(){
            breadcrumbs();
        },
        onLeave:function(index,nextIndex){
            switchAnchor(nextIndex);
        }
    });

    $('[data-toggle="tooltip"]').tooltip();

	$('.summary a').matchHeight({byRow:true});
});

$('.recomandation').click(function(){
    var nexts = $('div.section.active').nextUntil('.bg-recomandation').length;
    for (i = 0; i <= nexts; i++) {
        $.fn.fullpage.moveSectionDown();
    }
    $(this).slideUp(function(){
        $(this).slideDown();
    });
});

$('.nav-toggle').click(function(){
    $(this).toggleClass('active');
    if ($('.navbar-collapse').hasClass('active')) {
        $('.navbar-collapse').removeClass('active').css('max-height',0);
    } else {
        $('.navbar-collapse').addClass('active').css('max-height',$(window).height()-$('#header').height());
    }
});

$(window).resize(function(){
    if ($('.navbar-collapse').hasClass('active')) {
        $('.navbar-collapse').css('max-height',$(window).height()-$('#header').height());
    }
});

function breadcrumbs(){
    var bread, level, start,item;
    if ( $('.fp-section.active').data('level') != undefined) {
        level = $('.fp-section.active').data('level');
        start = $('.fp-section.active');
    } else {
        level = $('.fp-section.active').prevAll('[data-level]').first().data('level');
        start = $('.fp-section.active').prevAll('[data-level]').first();
    }
    if ( $('.fp-section.active').data('level') == 1 ){
        $('#breadcrumbs').html('');
    } else if ( level == 1 ) {
        bread = start.find('h1,h2,h3').first().text().replace(/(\r\n|\n|\r)/gm, "");
    } else {
        bread = ' > '+ start.find('h1,h2,h3').first().text().replace(/(\r\n|\n|\r)/gm, "");
        for (i = level - 1; i > 0; i--) {
            item = start.prevAll('[data-level="' + i + '"]').first();
            if ( i == 1) {
                bread = '<a href="#'+item.data('anchor')+'">'+item.find('h1,h2,h3').first().text().replace(/(\r\n|\n|\r)/gm, "")+'</a>' + bread;
            } else {
                bread = ' > <a href="#'+item.data('anchor')+'">'+item.find('h1,h2,h3').first().text().replace(/(\r\n|\n|\r)/gm, "")+'</a>' + bread;
            }
        }
    }
    $('#breadcrumbs').html(bread);
}

function getAnchors(tooltips) {
	var anchors = [], count = 0;
	$('#fullpage > .section').each(function(){
		anchors.push(Boolean($(this).data('menu')) ? (tooltips ? $('h1,h2,h3', this).first().text() : String(++count)) :'');
	});
	return anchors;
}
function switchAnchor(nextIndex) {
    $('#fp-nav a.parent').removeClass('parent');
    if ( $('#fp-nav li').eq(nextIndex-1).is(':hidden') ) {
        $('#fp-nav li').eq(nextIndex-1).prevAll(':visible').first().find('a').addClass('parent');
    }
}
